import { Body } from '@assembly-js/design-system';
import React from 'react';

export const ErrorText: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="text-error-primary">
    <Body className="font-medium leading-6" size="sm" tag="div">
      {children}
    </Body>
  </div>
);
